<template>
  <div class="border-b border-creme-200 pb-2 mb-2">
    <div class="px-4 py-2 text-left font-body text-primary font-semibold mb-2">
      Language
    </div>
    <div v-if="showLanguageMenu" class="space-y-1">
      <div v-if="regionalLanguages.length > 0" class="mb-2">
        <div class="px-4 py-1 text-xs font-marketing font-semibold text-gray-400 mb-1">
          {{ regionLabel }}
        </div>
        <button v-for="code in regionalLanguages" :key="code" @click="selectLanguage(code)" :class="[
          'block w-full text-left px-4 py-2 text-sm transition-colors font-marketing',
          currentLanguage === code
            ? 'text-green-700 border-l-4 border-green-700 bg-creme-100 font-semibold'
            : 'text-primary hover:bg-creme-100'
        ]">
          {{ languages[code] || code }}
        </button>
      </div>
      <div>
        <div class="px-4 py-1 text-xs font-marketing font-semibold text-gray-400 mb-1">
          All Languages
        </div>
        <button v-for="(name, code) in languages" :key="code" @click="selectLanguage(code)" :class="[
          'block w-full text-left px-4 py-2 text-sm transition-colors font-marketing',
          currentLanguage === code
            ? 'text-green-700 border-l-4 border-green-700 bg-creme-100 font-semibold'
            : 'text-primary hover:bg-creme-100'
        ]">
          {{ name }}
        </button>
      </div>
    </div>
    <button v-else @click="showLanguageMenu = true" :class="[
      'block w-full text-left px-4 py-2 transition-colors font-body',
      'text-primary hover:bg-creme-100'
    ]">
      <div class="flex items-center justify-between">
        <span>{{ languages[currentLanguage] || 'English' }}</span>
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </button>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { translationService } from '../services/translation'

const props = defineProps({
  isOpen: { type: Boolean, default: false }
})

const emit = defineEmits(['close'])

const showLanguageMenu = ref(false)
const languages = ref({ en: 'English' })
const regionalLanguages = ref([])
const countryCode = ref(null)
const currentLanguage = ref(translationService.getLanguage())

const regionLabel = computed(() => {
  if (!countryCode.value) return 'Recommended'
  const regionNames = {
    'KE': 'Kenya',
    'TZ': 'Tanzania',
    'UG': 'Uganda',
    'RW': 'Rwanda',
    'BI': 'Burundi',
    'CD': 'DR Congo',
    'IN': 'India',
    'BD': 'Bangladesh',
    'PK': 'Pakistan',
    'TH': 'Thailand',
    'VN': 'Vietnam',
    'ID': 'Indonesia',
    'MY': 'Malaysia',
    'SG': 'Singapore',
    'ZA': 'South Africa',
    'ET': 'Ethiopia',
    'NG': 'Nigeria',
  }
  return regionNames[countryCode.value] || 'Your Region'
})


const selectLanguage = async (code) => {
  currentLanguage.value = code
  translationService.setLanguage(code)
  showLanguageMenu.value = false
  emit('close')
}

watch(
  () => props.isOpen,
  (isOpen) => {
    if (!isOpen) {
      showLanguageMenu.value = false
    }
  }
)

onMounted(async () => {
  const response = await translationService.getSupportedLanguages()
  languages.value = response.all || response
  regionalLanguages.value = response.regional || []
  if (response.country_code) {
    countryCode.value = response.country_code
  }
})
</script>

<style scoped></style>
